<template>
<div>
    <selectize :id="'select-'+id" v-model="current" :placeholder="placeholder" :settings="settings" />
</div>
</template>

<script>
import Selectize from 'vue2-selectize'
import 'selectize/dist/css/selectize.bootstrap3.css'

export default {
    name: "DropdownServerSearchInput",
    components: {
      Selectize
    },
    data() {
        return {
            items: null,
            settings: {
                valueField: 'id',
                labelField: 'value',
                searchField: 'value',
                options: [],
                create: false,
                maxOptions: 100,
                loadThrottle: 250,
                render: {
                    option: function(item, escape) {
                        return '<div>' +
                        '<span class="description">' + escape(item.value) + '</span>' +
                        '</div>';
                    }
                },
                load: (query, callback) => {
                    if (!query.length) return callback();
                    axios
                    .post(this.get, {
                        query: query
                    })
                    .then(response => {
                        this.items = response.data.items;
                        var selectize = $('#select-'+this.id)[0].selectize;
                        selectize.clearOptions();
                        callback(response.data.items)
                    }).catch(e => {
                        console.log(e)
                        callback();
                    });
                }
            },
            current: null
        };
    },
    props: ["id", "get", "placeholder"],

    watch: {
        'current': function(value) {
            let item = this.items.find(x => x.id == value);
            this.$emit('select-change', item)
        }
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/input/DropdownServerSearchInput.vue